import { useTranslation } from "react-i18next";
import { useSelectedPsychologist } from "./hooks/useSelectedPsychologist";
import { Dialog, Icon, Spacing, Button } from "@mindlercare/ui-web";
import { Typography } from "components/typography";
import { useFlag } from "@mindlercare/unleash-client";

export const PsychologistInfoDialog = () => {
  const { t } = useTranslation();
  const selectedPsychologist = useSelectedPsychologist();
  const hideComponent = useFlag("HIDE_MC_PSYCHOLOGIST_STATUSES");

  if (hideComponent) return null;

  return (
    <Dialog
      trigger={
        <Dialog.Trigger
          title={t("PSYCHOLOGIST_STATUSES.SHOW_PSYCHOLOGIST_INFO")}
          variant="icon"
          disabled={!selectedPsychologist}
        >
          <Icon.Account />
        </Dialog.Trigger>
      }
    >
      <Dialog.Title>
        <Spacing b={4} r={70}>
          <Typography variant="h1">
            {selectedPsychologist?.user?.firstName}{" "}
            {selectedPsychologist?.user?.lastName}
          </Typography>
        </Spacing>
      </Dialog.Title>

      <Dialog.Content>
        <Spacing t={12}>
          <Typography variant="h3">
            {t("PSYCHOLOGIST_STATUSES.EMPLOYMENT")}
          </Typography>
          <Button variant="secondary" mt={8}>
            {selectedPsychologist?.employmentType === "full-time" &&
              t("PSYCHOLOGIST_STATUSES.EMPLOYMENT_FULL_TIME")}
            {selectedPsychologist?.employmentType === "part-time" &&
              t("PSYCHOLOGIST_STATUSES.EMPLOYMENT_PART_TIME")}
            {!selectedPsychologist?.employmentType && t("UNKNOWN")}
          </Button>
        </Spacing>

        <Spacing t={18} b={18}>
          <Typography variant="h3">{t("STATUS")}</Typography>
          <Button variant="secondary" mt={8}>
            {selectedPsychologist?.absenceStatus === "absent"
              ? t("PSYCHOLOGIST_STATUSES.ABSENCE_STATUS_ON_LEAVE")
              : t("PSYCHOLOGIST_STATUSES.ABSENCE_STATUS_ACTIVE")}
          </Button>
        </Spacing>
      </Dialog.Content>
    </Dialog>
  );
};
